/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'
import { useState,useRef } from 'react';
import { useOnClickOutside } from '../../../../../../CommonMethods/OutsideClick';

const BloodGlouseVitalTable=({pageNumber,List,    wellnessDetails,handleSearchParams,sortValue,setisSortSelected,setConfirmationState,setTextAreaMsg,device})=>{
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    
    return(
        <div className={`${wellnessDetails?.patientData?.wellness_reading_count!=='-' ? '2xl:h-[calc(100vh-286px)]' : '2xl:h-[calc(100vh-265px)]'} ${wellnessDetails?.patientData?.wellness_reading_count!=='-' ? 'xl:h-[calc(100vh-284px)]' : 'xl:h-[calc(100vh-265px)]'} ${wellnessDetails?.patientData?.wellness_reading_count!=='-'  ? 'h-[calc(100vh-286px)]' : 'h-[calc(100vh-265px)]'} overflow-auto scrollbar_purple pb-2.5`} onScroll={()=>setSelectedIndex('')}>
            <table aria-label="Outside Table" className="w-full table-auto">
                <thead>
                    <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                        <th className="px-[9px] py-2 min-w-[195px]"  >
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Timestamp
                            </span>
                        </th>
                        <th className="px-[9px] py-2 min-w-[180px]">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Type
                            </span>
                        </th>
                        <th className="px-[9px] py-2 min-w-[120px]">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading
                            </span>
                        </th>
                        <th className="px-[9px] py-2 min-w-[160px]" >
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alert Type
                            </span>
                        </th>
                        <th className="px-[9px] py-2 min-w-[140px]">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Details
                            </span>
                        </th>
                        <th className="px-[9px] py-2 min-w-[130px]">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Threshold
                            </span>
                        </th>
                        <th className="px-[9px] py-2 min-w-[160px] rounded-tl-sm rounded-bl-sm">
                            <span className="flex items-center text-sm font-normal text-[#000000]">Device ID
                            </span>
                        </th>                           
                    </tr>
                </thead>
                <tbody>
                    {List?.historical_reading?.map((item,index)=>(
                        <Fragment key={item._id}>
                            <TableBody
                                tableData={item}
                                List={List}
                                indexNum={index}
                                pageNumber={pageNumber}
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                selectedRef={selectedRef}
                                lastIndex={List?.data?.length}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}
                                device={device}
                            />
                        </Fragment>
                    ))}
                        
        
                </tbody>
                    
            </table>

        </div>
    )
}

export default BloodGlouseVitalTable;